import { createSlice } from "@reduxjs/toolkit";
import clientConfig from "../clientConfig";

// Define the shape of the state
interface LinksState {
  logoHorizontal: string;
  logoVertical: string;
  topImage: string;
  topImage1: string;
  topImage2: string;
  topImage3: string;
  topImage1Mobile: string;
  topImage2Mobile: string;
  topImage3Mobile: string;
  israelMap: string;
  israelMapMobile: string;
  oliveTree: string;
}
// Define the initial state
const initialLinksState: LinksState = {
  logoHorizontal: `${clientConfig.dbUrl}/wp-content/react_images/morasha_logo_horizontal.svg?v=1`,
  logoVertical: `${clientConfig.dbUrl}/wp-content/react_images/morasha_logo.svg?v=1`,
  topImage: `${clientConfig.dbUrl}/wp-content/react_images/topImage2.jpg?v=1`,
  topImage1: `${clientConfig.dbUrl}/wp-content/react_images/topImage1.jpg?v=1`,
  topImage2: `${clientConfig.dbUrl}/wp-content/react_images/topImage2.jpg?v=1`,
  topImage3: `${clientConfig.dbUrl}/wp-content/react_images/topImage3.jpg?v=1`,
  topImage1Mobile: `${clientConfig.dbUrl}/wp-content/react_images/topImage1Mobile.jpg?v=1`,
  topImage2Mobile: `${clientConfig.dbUrl}/wp-content/react_images/topImage2Mobile.jpg?v=1`,
  topImage3Mobile: `${clientConfig.dbUrl}/wp-content/react_images/topImage3Mobile.jpg?v=1`,
  israelMap: `${clientConfig.dbUrl}/wp-content/react_images/israelMap.jpg?v=1`,
  israelMapMobile: `${clientConfig.dbUrl}/wp-content/react_images/israelMapMobile.jpg?v=2`,
  oliveTree: `${clientConfig.dbUrl}/wp-content/react_images/oliveTree.jpg?v=1`,
};

const linksSlice = createSlice({
  name: "links",
  initialState: initialLinksState,
  reducers: {},
});

export default linksSlice.reducer;
